import VueI18n from 'vue-i18n'
import localesCS from "@/../locales/cs.json";
import localesEN from "@/../locales/en.json";
import localesSK from "@/../locales/sk.json";
import localesDE from "@/../locales/de.json";
import localesPL from "@/../locales/pl.json";

const messages = {
    'cs-CZ': localesCS,
    'en-GB': localesEN,
    'en-CZ': localesEN,
    'sk-SK': localesSK,
    'de-DE': localesDE,
    'pl-PL': localesPL,
};
const numberFormats = {
    'cs-CZ': {
        priceWithoutCurrency: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        currencyCZK: {
            style: 'currency',
            currency: 'CZK',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        currencyEUR: {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
        currencyEUR0: {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }
    },
    'sk-SK': {
        priceWithoutCurrency: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        currencyCZK: {
            style: 'currency',
            currency: 'CZK',
            minimumFractionDigits: 0,
            currencyDisplay: 'code',
        },
        currencyEUR: {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        currencyEUR0: {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }
    },
    'en-GB': {
        priceWithoutCurrency: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        currencyCZK: {
            style: 'currency',
            currency: 'CZK',
            minimumFractionDigits: 0,
            currencyDisplay: 'code',
        },
        currencyEUR: {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        currencyEUR0: {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }
    },
    'de-DE': {
        priceWithoutCurrency: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        currencyCZK: {
            style: 'currency',
            currency: 'CZK',
            minimumFractionDigits: 0,
            currencyDisplay: 'code',
        },
        currencyEUR: {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        currencyEUR0: {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }
    },
    'pl-PL': {
        priceWithoutCurrency: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        currencyCZK: {
            style: 'currency',
            currency: 'CZK',
            minimumFractionDigits: 0,
            currencyDisplay: 'code',
        },
        currencyEUR: {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        currencyEUR0: {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }
    },
}

const appLang = {
    'default': 'cs-CZ',
    'cs': 'cs-CZ',
    'sk': 'sk-SK',
    'en': 'en-GB',
    'de': 'de-DE',
    'pl': 'pl-PL',
};

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: appLang[document.documentElement.lang] ? appLang[document.documentElement.lang] : appLang['default'], // set locale
    messages, // set locale messages
    numberFormats, // number formats
});

export default i18n;
